import ECheckModalMobile from './ECheckModalMobile';

export default ECheckModalMobile;
